/*
 * VersionChecker.tsx
 *
 * Created by Dr. Maximillian Dornseif Tue Aug 31 18:01:12 2021 in huWaWi3
 * Copyright (c) 2023 HUDORA GmbH
 */

import gql from 'graphql-tag'
import React from 'react'
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import semver from 'semver'
import { useQuery as useQuery2 } from 'urql'

import { hudora } from '../../../package.json'

const queryClient = new QueryClient()

export function VersionChecker() {
  return (
    <QueryClientProvider client={queryClient}>
      <ClientVersionCheckerInner />
    </QueryClientProvider>
  )
}
function ClientVersionCheckerInner() {
  const { data } = useQuery('repoData', () => fetch('/meta.json').then((res) => res.json()), {
    retry: true,
    refetchInterval: 600 * 1000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
  // Client Version
  if (data?.version !== undefined) {
    try {
      if (semver.lt(`${process.env.REACT_APP_VERSION}`, `${data?.version}`)) {
        const style: React.CSSProperties = {
          backgroundColor: 'rgb(255, 244, 206)',
          padding: '1em',
          width: '100%',
          marginBottom: '1em',
        }

        return (
          <div style={style}>
            Es ist eine neuere Version {data?.version} der Applikation verfügbar. Sie nutzen Version{' '}
            {process.env.REACT_APP_VERSION} von {process.env.REACT_APP_NAME}. Klicken sie{' '}
            <a href={`/doc/c/frontend/?v=${data?.version}`}>hier</a>, um die neue Version zu starten. Oder
            drücken Sie einfach <code>⌘+R</code> auf dem Mac beziehungsweise <code>F5</code> auf Windows.
          </div>
        )
      }
    } catch (e) {
      console.log('SemVer can not be parsed:', e)
    }
  }
  return null
}

const SERVER_QUERY = gql`
  query ServerVersionQuery {
    server {
      version
      gitSha
      timestamp
      nodeVersion
      env {
        GAE_SERVICE
        GAE_VERSION
      }
    }
  }
`

export function ServerVersionChecker() {
  const [result] = useQuery2({ query: SERVER_QUERY })
  const { data, fetching: loading, error } = result

  // Server version
  try {
    const requiredVersion = hudora.serverVersion
    const providedVersion = data?.server?.version
    if (providedVersion) {
      const ok = semver.satisfies(providedVersion, requiredVersion)
      if (!ok) {
        const style: React.CSSProperties = {
          backgroundColor: 'rgb(255, 244, 206)',
          padding: '1em',
          width: '100%',
          marginBottom: '1em',
        }

        return (
          <div style={style}>
            Das Backend läuft unter Version {providedVersion}. Dies Frontend ({process.env.REACT_APP_VERSION})
            benötigt aber Backend Version {requiredVersion}. Das ist ein Installationsfehler. Vermutlich wird
            irgendwas nicht funktionieren.
          </div>
        )
      }
    }
  } catch (e) {
    console.log('SemVer can not be parsed:', e)
  }
  return null
}
